module.exports = __webpack_public_path__ + "static/05-6d9e891abef2359339e6ebc9175ca070.jpg";